import React, { lazy } from 'react';

import { Outlet } from 'react-router-dom';

import { useInjectReducer } from 'utils/common/injectedReducers';
import { useInjectSaga } from 'utils/common/injectSaga';
import reducer from './controllers/reducer';
import saga from './controllers/saga';
import SuspenseLoading from 'common/components/loading/SuspendLoading';

import 'pages/maintenance-form/components/container/Containers.less';

const key = 'maintenanceForm';

const FormDetailExcel = lazy(
  () => import('pages/maintenance-form/views/form-detail-xls')
);

const FormDetailDoc = lazy(
  () => import('pages/maintenance-form/views/form-detail-doc')
);

const FormDetailPowerpoint = lazy(
  () => import('pages/maintenance-form/views/form-detail-ppt')
);

const FormGrid = lazy(() => import('pages/maintenance-form/views/form-grid'));

const FormUpload = lazy(
  () => import('pages/maintenance-form/views/form-upload')
);

const SplashFormHistoryGrid = lazy(
  () => import('pages/maintenance-form/views/splash-form-history-by-member')
);
const SplashFormHistoryEntityGrid = lazy(
  () => import('pages/maintenance-form/views/splash-form-history-by-entity')
);

// Routes that will be nested under /maintenance/form
export const maintenanceFormNestedRoutes = [
  {
    index: true, // Handles /maintenance/form
    element: <FormGrid />,
  },
  {
    path: 'upload', // Handles /maintenance/form/upload
    element: <FormUpload />,
  },
  {
    path: 'excel/:id', // Handles /maintenance/form/excel/:id
    element: <FormDetailExcel />,
  },
  {
    path: 'word/:id', // Handles /maintenance/form/word/:id
    element: <FormDetailDoc />,
  },
  {
    path: 'powerpoint/:id', // Handles /maintenance/form/powerpoint/:id
    element: <FormDetailPowerpoint />,
  },
];

// Routes that will be at the same level (siblings)
export const maintenanceFormSiblingRoutes = [
  {
    path: 'exported-splash-forms',
    element: <SplashFormHistoryGrid />,
  },
  {
    path: 'history-splash-form/:entityType/:entityId',
    element: <SplashFormHistoryEntityGrid />,
  },
];

const MaintenanceForm = () => {
  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });

  return (
    <SuspenseLoading>
      <Outlet />
    </SuspenseLoading>
  );
};

export default MaintenanceForm;
